// extracted by mini-css-extract-plugin
export default {"wrapper":"Error_wrapper__ncIZd","amprimary":"Error_amprimary__YK450"};